module.exports = __webpack_public_path__ + "static/media/XRP.b8fc67f4.svg";